const Regions = [
  {
    id: 1,
    label: "Afghanistan",
    value: "afghan",
    optionType: "primary",
    capital: "Kabul",
    capitalCoords: {
      lat: 34.5253,
      long: 69.1783,
    },
  },
  {
    id: 2,
    label: "Albania",
    value: "albania",
    optionType: "primary",
    capital: "Tirana",
    capitalCoords: {
      lat: 41.3289,
      long: 19.8178,
    },
  },
  {
    id: 3,
    label: "Algeria",
    value: "algeria",
    optionType: "primary",
    capital: "Algiers",
    capitalCoords: {
      lat: 36.7539,
      long: 3.0589,
    },
  },
  {
    id: 4,
    label: "Andorra",
    value: "andorra",
    optionType: "primary",
    capital: "Andorra La Vella",
    capitalCoords: {
      lat: 42.5,
      long: 1.5,
    },
  },
  {
    id: 5,
    label: "Angola",
    value: "angola",
    optionType: "primary",
    capital: "Luanda",
    capitalCoords: {
      lat: -8.8383,
      long: 13.2344,
    },
  },
  {
    id: 6,
    label: "Antigua and Barbuda",
    value: "antigua-b",
    optionType: "primary",
    capital: "Saint John's",
    capitalCoords: { lat: 17.1166662, long: -61.8499966 },
  },
  {
    id: 7,
    label: "Argentina",
    value: "argentina",
    optionType: "primary",
    capital: "Buenos Aires",
    capitalCoords: {
      lat: -34.6033,
      long: -58.3817,
    },
  },
  {
    id: 8,
    label: "Armenia",
    value: "armenia",
    optionType: "primary",
    capital: "Yerevan",
    capitalCoords: {
      lat: 40.1814,
      long: 44.5144,
    },
  },
  {
    id: 9,
    label: "Australia",
    value: "australia",
    optionType: "primary",
    capital: "Canberra",
    capitalCoords: {
      lat: -35.2931,
      long: 149.1269,
    },
  },
  {
    id: 10,
    label: "Austria",
    value: "austria",
    optionType: "primary",
    capital: "Vienna",
    capitalCoords: {
      lat: 48.2083,
      long: 16.3725,
    },
  },
  {
    id: 11,
    label: "Azerbaijan",
    value: "azerbaijan",
    optionType: "primary",
    capital: "Baku",
    capitalCoords: {
      lat: 40.3953,
      long: 49.8822,
    },
  },
  {
    id: 12,
    label: "Bahamas",
    value: "bahamas",
    optionType: "primary",
    capital: "Nassau",
    capitalCoords: {
      lat: 25.0781,
      long: -77.3386,
    },
  },
  {
    id: 13,
    label: "Bahrain",
    value: "bahrain",
    optionType: "primary",
    capital: "Manama",
    capitalCoords: {
      lat: 26.225,
      long: 50.5775,
    },
  },
  {
    id: 14,
    label: "Bangladesh",
    value: "bangladesh",
    optionType: "primary",
    capital: "Dhaka",
    capitalCoords: {
      lat: 23.7639,
      long: 90.3889,
    },
  },
  {
    id: 15,
    label: "Barbados",
    value: "barbados",
    optionType: "primary",
    capital: "Bridgetown",
    capitalCoords: {
      lat: 13.0975,
      long: -59.6167,
    },
  },
  {
    id: 16,
    label: "Belarus",
    value: "belarus",
    optionType: "primary",
    capital: "Minsk",
    capitalCoords: {
      lat: 53.9,
      long: 27.5667,
    },
  },
  {
    id: 17,
    label: "Belgium",
    value: "belgium",
    optionType: "primary",
    capital: "Brussels",
    capitalCoords: {
      lat: 50.8467,
      long: 4.3525,
    },
  },
  {
    id: 18,
    label: "Belize",
    value: "belize",
    optionType: "primary",
    capital: "Belmopan",
    capitalCoords: {
      lat: 17.2514,
      long: -88.7669,
    },
  },
  {
    id: 19,
    label: "Benin",
    value: "benin",
    optionType: "primary",
    capital: "Porto-Novo",
    capitalCoords: {
      lat: 6.4972,
      long: 2.605,
    },
  },
  {
    id: 20,
    label: "Bhutan",
    value: "bhutan",
    optionType: "primary",
    capital: "Thimphu",
    capitalCoords: {
      lat: 27.4722,
      long: 89.6361,
    },
  },
  {
    id: 21,
    label: "Bolivia",
    value: "bolivia",
    optionType: "primary",
    capital: "Sucre",
    capitalCoords: {
      lat: -19.0475,
      long: -65.26,
    },
  },
  {
    id: 22,
    label: "Bosnia and Herzegovina",
    value: "bosnia-h",
    optionType: "primary",
    capital: "Sarajevo",
    capitalCoords: {
      lat: 43.8564,
      long: 18.4131,
    },
  },
  {
    id: 23,
    label: "Botswana",
    value: "botswana",
    optionType: "primary",
    capital: "Gaborone",
    capitalCoords: {
      lat: -24.6581,
      long: 25.9122,
    },
  },
  {
    id: 24,
    label: "Brazil",
    value: "brazil",
    optionType: "primary",
    capital: "Brasília",
    capitalCoords: {
      lat: -15.7939,
      long: -47.8828,
    },
  },
  {
    id: 25,
    label: "Brunei",
    value: "brunei",
    optionType: "primary",
    capital: "Bandar Seri Begawan",
    capitalCoords: {
      lat: 4.8903,
      long: 114.9422,
    },
  },
  {
    id: 26,
    label: "Bulgaria",
    value: "bulgaria",
    optionType: "primary",
    capital: "Sofia",
    capitalCoords: {
      lat: 42.7,
      long: 23.33,
    },
  },
  {
    id: 27,
    label: "Burkina Faso",
    value: "burkina-f",
    optionType: "primary",
    capital: "Ouagadougou",
    capitalCoords: {
      lat: 12.3686,
      long: -1.5275,
    },
  },
  {
    id: 28,
    label: "Burundi",
    value: "burundi",
    optionType: "primary",
    capital: "Gitega",
    capitalCoords: {
      lat: -3.4283,
      long: 29.925,
    },
  },
  {
    id: 29,
    label: "Cabo Verde",
    value: "cabo-verde",
    optionType: "primary",
    capital: "Praia",
    capitalCoords: {
      lat: 14.918,
      long: -23.509,
    },
  },
  {
    id: 30,
    label: "Cambodia",
    value: "cambodia",
    optionType: "primary",
    capital: "Phnom Penh",
    capitalCoords: {
      lat: 11.5694,
      long: 104.9211,
    },
  },
  {
    id: 31,
    label: "Cameroon",
    value: "cameroon",
    optionType: "primary",
    capital: "Yaoundé",
    capitalCoords: {
      lat: 3.8667,
      long: 11.5167,
    },
  },
  {
    id: 32,
    label: "Canada",
    value: "canada",
    optionType: "primary",
    capital: "Ottawa",
    capitalCoords: {
      lat: 45.4247,
      long: -75.695,
    },
  },
  {
    id: 33,
    label: "Central African Republic",
    value: "cent-afr",
    optionType: "primary",
    capital: "Bangui",
    capitalCoords: {
      lat: 4.3733,
      long: 18.5628,
    },
  },
  {
    id: 34,
    label: "Chad",
    value: "chad",
    optionType: "primary",
    capital: "N'djamena",
    capitalCoords: { lat: 12.137752, long: 15.054325 },
  },
  {
    id: 35,
    label: "Chile",
    value: "chile",
    optionType: "primary",
    capital: "Santiago",
    capitalCoords: {
      lat: -33.4372,
      long: -70.6506,
    },
  },
  {
    id: 36,
    label: "China",
    value: "china",
    optionType: "primary",
    capital: "Beijing",
    capitalCoords: {
      lat: 39.9067,
      long: 116.3975,
    },
  },
  {
    id: 37,
    label: "Colombia",
    value: "colombia",
    optionType: "primary",
    capital: "Bogotá",
    capitalCoords: {
      lat: 4.7111,
      long: -74.0722,
    },
  },
  {
    id: 38,
    label: "Comoros",
    value: "comoros",
    optionType: "primary",
    capital: "Moroni",
    capitalCoords: {
      lat: -11.699,
      long: 43.256,
    },
  },
  {
    id: 39,
    label: "Congo, Democratic Republic of the",
    value: "congo-dr",
    optionType: "primary",
    capital: "Kinshasa",
    capitalCoords: {
      lat: -4.3219,
      long: 15.3119,
    },
  },
  {
    id: 40,
    label: "Congo, Republic of the",
    value: "congo-r",
    optionType: "primary",
    capital: "Brazzaville",
    capitalCoords: {
      lat: -4.2694,
      long: 15.2711,
    },
  },
  {
    id: 41,
    label: "Costa Rica",
    value: "costa-rica",
    optionType: "primary",
    capital: "San José",
    capitalCoords: {
      lat: 9.9325,
      long: -84.08,
    },
  },
  {
    id: 42,
    label: "Croatia",
    value: "croatia",
    optionType: "primary",
    capital: "Zagreb",
    capitalCoords: {
      lat: 45.8131,
      long: 15.9775,
    },
  },
  {
    id: 43,
    label: "Cuba",
    value: "cuba",
    optionType: "primary",
    capital: "Havana",
    capitalCoords: {
      lat: 23.1367,
      long: -82.3589,
    },
  },
  {
    id: 44,
    label: "Cyprus",
    value: "cyprus",
    optionType: "primary",
    capital: "Nicosia",
    capitalCoords: {
      lat: 35.1725,
      long: 33.365,
    },
  },
  {
    id: 45,
    label: "Czech Republic",
    value: "czech-rep",
    optionType: "primary",
    capital: "Prague",
    capitalCoords: {
      lat: 50.0875,
      long: 14.4214,
    },
  },
  {
    id: 46,
    label: "Denmark",
    value: "denmark",
    optionType: "primary",
    capital: "Copenhagen",
    capitalCoords: {
      lat: 55.6761,
      long: 12.5683,
    },
  },
  {
    id: 47,
    label: "Djibouti",
    value: "djibouti",
    optionType: "primary",
    capital: "Djibouti",
    capitalCoords: {
      lat: 11.5883,
      long: 43.145,
    },
  },
  {
    id: 48,
    label: "Dominica",
    value: "dominica",
    optionType: "primary",
    capital: "Roseau",
    capitalCoords: {
      lat: 15.3014,
      long: -61.3883,
    },
  },
  {
    id: 49,
    label: "Dominican Republic",
    value: "dominican-r",
    optionType: "primary",
    capital: "Santo Domingo",
    capitalCoords: {
      lat: 18.4667,
      long: -69.95,
    },
  },
  {
    id: 50,
    label: "Ecuador",
    value: "ecuador",
    optionType: "primary",
    capital: "Quito",
    capitalCoords: {
      lat: -0.22,
      long: -78.5125,
    },
  },
  {
    id: 51,
    label: "Egypt",
    value: "egypt",
    optionType: "primary",
    capital: "Cairo",
    capitalCoords: {
      lat: 30.0444,
      long: 31.2358,
    },
  },
  {
    id: 52,
    label: "El Salvador",
    value: "el-salvador",
    optionType: "primary",
    capital: "San Salvador",
    capitalCoords: {
      lat: 13.6989,
      long: -89.1914,
    },
  },
  {
    id: 53,
    label: "Equatorial Guinea",
    value: "equatorial-g",
    optionType: "primary",
    capital: "Malabo",
    capitalCoords: {
      lat: 3.7456,
      long: 8.7744,
    },
  },
  {
    id: 54,
    label: "Eritrea",
    value: "eritrea",
    optionType: "primary",
    capital: "Asmara",
    capitalCoords: {
      lat: 15.3228,
      long: 38.925,
    },
  },
  {
    id: 55,
    label: "Estonia",
    value: "estonia",
    optionType: "primary",
    capital: "Tallinn",
    capitalCoords: {
      lat: 59.4372,
      long: 24.7453,
    },
  },
  {
    id: 56,
    label: "Eswatini",
    value: "eswatini",
    optionType: "primary",
    capital: "Mbabane",
    capitalCoords: {
      lat: -26.3167,
      long: 31.1333,
    },
  },
  {
    id: 57,
    label: "Ethiopia",
    value: "ethiopia",
    optionType: "primary",
    capital: "Addis Ababa",
    capitalCoords: {
      lat: 9.03,
      long: 38.74,
    },
  },
  {
    id: 58,
    label: "Fiji",
    value: "fiji",
    optionType: "primary",
    capital: "Suva",
    capitalCoords: {
      lat: -18.1416,
      long: 178.4419,
    },
  },
  {
    id: 59,
    label: "Finland",
    value: "finland",
    optionType: "primary",
    capital: "Helsinki",
    capitalCoords: {
      lat: 60.1708,
      long: 24.9375,
    },
  },
  {
    id: 60,
    label: "France",
    value: "france",
    optionType: "primary",
    capital: "Paris",
    capitalCoords: {
      lat: 48.8567,
      long: 2.3522,
    },
  },
  {
    id: 61,
    label: "Gabon",
    value: "gabon",
    optionType: "primary",
    capital: "Libreville",
    capitalCoords: {
      lat: 0.3903,
      long: 9.4542,
    },
  },
  {
    id: 62,
    label: "Gambia",
    value: "gambia",
    optionType: "primary",
    capital: "Banjul",
    capitalCoords: {
      lat: 13.4531,
      long: -16.5775,
    },
  },
  {
    id: 63,
    label: "Georgia",
    value: "georgia",
    optionType: "primary",
    capital: "Tbilisi",
    capitalCoords: {
      lat: 41.7225,
      long: 44.7925,
    },
  },
  {
    id: 64,
    label: "Germany",
    value: "germany",
    optionType: "primary",
    capital: "Berlin",
    capitalCoords: {
      lat: 52.52,
      long: 13.405,
    },
  },
  {
    id: 65,
    label: "Ghana",
    value: "ghana",
    optionType: "primary",
    capital: "Accra",
    capitalCoords: {
      lat: 5.55,
      long: -0.2,
    },
  },
  {
    id: 66,
    label: "Greece",
    value: "greece",
    optionType: "primary",
    capital: "Athens",
    capitalCoords: {
      lat: 37.9842,
      long: 23.7281,
    },
  },
  {
    id: 67,
    label: "Grenada",
    value: "grenada",
    optionType: "primary",
    capital: "St. George's",
    capitalCoords: { lat: 12.053532, long: -61.749684 },
  },
  {
    id: 68,
    label: "Guatemala",
    value: "guatemala",
    optionType: "primary",
    capital: "Guatemala City",
    capitalCoords: {
      lat: 14.6133,
      long: -90.5353,
    },
  },
  {
    id: 69,
    label: "Guinea",
    value: "guinea",
    optionType: "primary",
    capital: "Conakry",
    capitalCoords: {
      lat: 9.5092,
      long: -13.7122,
    },
  },
  {
    id: 70,
    label: "Guinea-Bissau",
    value: "guinea-b",
    optionType: "primary",
    capital: "Bissau",
    capitalCoords: {
      lat: 11.85,
      long: -15.5667,
    },
  },
  {
    id: 71,
    label: "Guyana",
    value: "guyana",
    optionType: "primary",
    capital: "Georgetown",
    capitalCoords: {
      lat: 6.8058,
      long: -58.1508,
    },
  },
  {
    id: 72,
    label: "Haiti",
    value: "haiti",
    optionType: "primary",
    capital: "Port-Au-Prince",
    capitalCoords: {
      lat: 18.5333,
      long: -72.3333,
    },
  },
  {
    id: 73,
    label: "Honduras",
    value: "honduras",
    optionType: "primary",
    capital: "Tegucigalpa",
    capitalCoords: {
      lat: 14.1058,
      long: -87.2047,
    },
  },
  {
    id: 74,
    label: "Hungary",
    value: "hungary",
    optionType: "primary",
    capital: "Budapest",
    capitalCoords: {
      lat: 47.4925,
      long: 19.0514,
    },
  },
  {
    id: 75,
    label: "Iceland",
    value: "iceland",
    optionType: "primary",
    capital: "Reykjavik",
    capitalCoords: { lat: 64.128288, long: -21.827774 },
  },
  {
    id: 76,
    label: "India",
    value: "india",
    optionType: "primary",
    capital: "New Delhi",
    capitalCoords: {
      lat: 28.6139,
      long: 77.2089,
    },
  },
  {
    id: 77,
    label: "Indonesia",
    value: "indonesia",
    optionType: "primary",
    capital: "Jakarta",
    capitalCoords: {
      lat: -6.175,
      long: 106.8275,
    },
  },
  {
    id: 78,
    label: "Iran",
    value: "iran",
    optionType: "primary",
    capital: "Tehran",
    capitalCoords: {
      lat: 35.6892,
      long: 51.3889,
    },
  },
  {
    id: 79,
    label: "Iraq",
    value: "iraq",
    optionType: "primary",
    capital: "Baghdad",
    capitalCoords: {
      lat: 33.3153,
      long: 44.3661,
    },
  },
  {
    id: 80,
    label: "Ireland",
    value: "ireland",
    optionType: "primary",
    capital: "Dublin",
    capitalCoords: {
      lat: 53.35,
      long: -6.2603,
    },
  },
  {
    id: 81,
    label: "Israel",
    value: "israel",
    optionType: "primary",
    capital: "Jerusalem",
    capitalCoords: {
      lat: 31.7789,
      long: 35.2256,
    },
  },
  {
    id: 82,
    label: "Italy",
    value: "italy",
    optionType: "primary",
    capital: "Rome",
    capitalCoords: {
      lat: 41.8933,
      long: 12.4828,
    },
  },
  {
    id: 83,
    label: "Jamaica",
    value: "jamaica",
    optionType: "primary",
    capital: "Kingston",
    capitalCoords: {
      lat: 17.9714,
      long: -76.7931,
    },
  },
  {
    id: 84,
    label: "Japan",
    value: "japan",
    optionType: "primary",
    capital: "Tokyo",
    capitalCoords: {
      lat: 35.6897,
      long: 139.6922,
    },
  },
  {
    id: 85,
    label: "Jordan",
    value: "jordan",
    optionType: "primary",
    capital: "Amman",
    capitalCoords: {
      lat: 31.9497,
      long: 35.9328,
    },
  },
  {
    id: 86,
    label: "Kazakhstan",
    value: "kazakhstan",
    optionType: "primary",
    capital: "Nur-Sultan",
    capitalCoords: { lat: 51.1776, long: 71.433 },
  },
  {
    id: 87,
    label: "Kenya",
    value: "kenya",
    optionType: "primary",
    capital: "Nairobi",
    capitalCoords: {
      lat: -1.2864,
      long: 36.8172,
    },
  },
  {
    id: 88,
    label: "Kiribati",
    value: "kiribati",
    optionType: "primary",
    capital: "South Tarawa",
    capitalCoords: { lat: 1.348447, long: 173.018188 },
  },
  // {
  //   id: 89,
  //   label: "Korea, North",
  //   value: "korea-north",
  //   optionType: "primary",
  //   capital: "Pyongyang",
  //   capitalCoords: {
  //     lat: 39.0167,
  //     long: 125.7475,
  //   },
  // },
  {
    id: 90,
    label: "Korea, South",
    value: "korea-south",
    optionType: "primary",
    capital: "Seoul",
    capitalCoords: {
      lat: 37.56,
      long: 126.99,
    },
  },
  {
    id: 91,
    label: "Kosovo",
    value: "kosovo",
    optionType: "primary",
    capital: "Pristina",
    capitalCoords: {
      lat: 42.6633,
      long: 21.1622,
    },
  },
  {
    id: 92,
    label: "Kuwait",
    value: "kuwait",
    optionType: "primary",
    capital: "Kuwait City",
    capitalCoords: {
      lat: 29.3697,
      long: 47.9783,
    },
  },
  {
    id: 93,
    label: "Kyrgyzstan",
    value: "kyrgyzstan",
    optionType: "primary",
    capital: "Bishkek",
    capitalCoords: {
      lat: 42.8747,
      long: 74.6122,
    },
  },
  {
    id: 94,
    label: "Laos",
    value: "laos",
    optionType: "primary",
    capital: "Vientiane",
    capitalCoords: {
      lat: 17.98,
      long: 102.63,
    },
  },
  {
    id: 95,
    label: "Latvia",
    value: "latvia",
    optionType: "primary",
    capital: "Riga",
    capitalCoords: {
      lat: 56.9489,
      long: 24.1064,
    },
  },
  {
    id: 96,
    label: "Lebanon",
    value: "lebanon",
    optionType: "primary",
    capital: "Beirut",
    capitalCoords: {
      lat: 33.8983,
      long: 35.5057,
    },
  },
  {
    id: 97,
    label: "Lesotho",
    value: "lesotho",
    optionType: "primary",
    capital: "Maseru",
    capitalCoords: {
      lat: -29.31,
      long: 27.48,
    },
  },
  {
    id: 98,
    label: "Liberia",
    value: "liberia",
    optionType: "primary",
    capital: "Monrovia",
    capitalCoords: {
      lat: 6.3133,
      long: -10.8014,
    },
  },
  {
    id: 99,
    label: "Libya",
    value: "libya",
    optionType: "primary",
    capital: "Tripoli",
    capitalCoords: {
      lat: 32.8872,
      long: 13.1914,
    },
  },
  {
    id: 100,
    label: "Liechtenstein",
    value: "liechtenstein",
    optionType: "primary",
    capital: "Vaduz",
    capitalCoords: {
      lat: 47.141,
      long: 9.521,
    },
  },
  {
    id: 101,
    label: "Lithuania",
    value: "lithuania",
    optionType: "primary",
    capital: "Vilnius",
    capitalCoords: {
      lat: 54.6872,
      long: 25.28,
    },
  },
  {
    id: 102,
    label: "Luxembourg",
    value: "luxembourg",
    optionType: "primary",
    capital: "Luxembourg",
    capitalCoords: {
      lat: 49.6117,
      long: 6.1319,
    },
  },
  {
    id: 103,
    label: "Madagascar",
    value: "madagascar",
    optionType: "primary",
    capital: "Antananarivo",
    capitalCoords: {
      lat: -18.91,
      long: 47.525,
    },
  },
  {
    id: 104,
    label: "Malawi",
    value: "malawi",
    optionType: "primary",
    capital: "Lilongwe",
    capitalCoords: {
      lat: -13.9833,
      long: 33.7833,
    },
  },
  {
    id: 105,
    label: "Malaysia",
    value: "malaysia",
    optionType: "primary",
    capital: "Kuala Lumpur",
    capitalCoords: {
      lat: 3.1478,
      long: 101.6953,
    },
  },
  {
    id: 106,
    label: "Maldives",
    value: "maldives",
    optionType: "primary",
    capital: "Malé",
    capitalCoords: { lat: 1.924992, long: 73.399658 },
  },
  {
    id: 107,
    label: "Mali",
    value: "mali",
    optionType: "primary",
    capital: "Bamako",
    capitalCoords: {
      lat: 12.6392,
      long: -8.0028,
    },
  },
  {
    id: 108,
    label: "Malta",
    value: "malta",
    optionType: "primary",
    capital: "Valletta",
    capitalCoords: {
      lat: 35.8983,
      long: 14.5125,
    },
  },
  {
    id: 109,
    label: "Marshall Islands",
    value: "marshall-i",
    optionType: "primary",
    capital: "Majuro",
    capitalCoords: {
      lat: 7.0833,
      long: 171.3833,
    },
  },
  {
    id: 110,
    label: "Mauritania",
    value: "mauritania",
    optionType: "primary",
    capital: "Nouakchott",
    capitalCoords: {
      lat: 18.0858,
      long: -15.9785,
    },
  },
  {
    id: 111,
    label: "Mauritius",
    value: "mauritius",
    optionType: "primary",
    capital: "Port Louis",
    capitalCoords: {
      lat: -20.1644,
      long: 57.5042,
    },
  },
  {
    id: 112,
    label: "Mexico",
    value: "mexico",
    optionType: "primary",
    capital: "Mexico City",
    capitalCoords: {
      lat: 19.4333,
      long: -99.1333,
    },
  },
  {
    id: 113,
    label: "Micronesia",
    value: "micronesia",
    optionType: "primary",
    capital: "Palikir",
    capitalCoords: {
      lat: 6.9172,
      long: 158.1589,
    },
  },
  {
    id: 114,
    label: "Moldova",
    value: "moldova",
    optionType: "primary",
    capital: "Chișinău",
    capitalCoords: { lat: 47.00367, long: 28.907089 },
  },
  {
    id: 115,
    label: "Monaco",
    value: "monaco",
    optionType: "primary",
    capital: "Monaco",
    capitalCoords: {
      lat: 43.7333,
      long: 7.4167,
    },
  },
  {
    id: 116,
    label: "Mongolia",
    value: "mongolia",
    optionType: "primary",
    capital: "Ulan Bator",
    capitalCoords: { lat: 47.92123, long: 106.918556 },
  },
  {
    id: 117,
    label: "Montenegro",
    value: "montenegro",
    optionType: "primary",
    capital: "Podgorica",
    capitalCoords: {
      lat: 42.4414,
      long: 19.2628,
    },
  },
  {
    id: 118,
    label: "Morocco",
    value: "morocco",
    optionType: "primary",
    capital: "Rabat",
    capitalCoords: {
      lat: 34.0209,
      long: -6.8416,
    },
  },
  {
    id: 119,
    label: "Mozambique",
    value: "mozambique",
    optionType: "primary",
    capital: "Maputo",
    capitalCoords: {
      lat: -25.9667,
      long: 32.5833,
    },
  },
  {
    id: 120,
    label: "Myanmar",
    value: "myanmar",
    optionType: "primary",
    capital: "Naypyidaw",
    capitalCoords: { lat: 19.745, long: 96.12972 },
  },
  {
    id: 121,
    label: "Namibia",
    value: "namibia",
    optionType: "primary",
    capital: "Windhoek",
    capitalCoords: {
      lat: -22.57,
      long: 17.0836,
    },
  },
  {
    id: 122,
    label: "Nauru",
    value: "nauru",
    optionType: "primary",
    capital: "Yaren",
    capitalCoords: {
      lat: -0.5477,
      long: 166.9209,
    },
  },
  {
    id: 123,
    label: "Nepal",
    value: "nepal",
    optionType: "primary",
    capital: "Kathmandu",
    capitalCoords: {
      lat: 27.71,
      long: 85.32,
    },
  },
  {
    id: 124,
    label: "Netherlands",
    value: "netherlands",
    optionType: "primary",
    capital: "Amsterdam",
    capitalCoords: {
      lat: 52.3728,
      long: 4.8936,
    },
  },
  {
    id: 125,
    label: "New Zealand",
    value: "new-zealand",
    optionType: "primary",
    capital: "Wellington",
    capitalCoords: {
      lat: -41.2889,
      long: 174.7772,
    },
  },
  {
    id: 126,
    label: "Nicaragua",
    value: "nicaragua",
    optionType: "primary",
    capital: "Managua",
    capitalCoords: {
      lat: 12.1364,
      long: -86.2514,
    },
  },
  {
    id: 127,
    label: "Niger",
    value: "niger",
    optionType: "primary",
    capital: "Niamey",
    capitalCoords: {
      lat: 13.515,
      long: 2.1175,
    },
  },
  {
    id: 128,
    label: "Nigeria",
    value: "nigeria",
    optionType: "primary",
    capital: "Abuja",
    capitalCoords: {
      lat: 9.0667,
      long: 7.4833,
    },
  },
  {
    id: 129,
    label: "North Macedonia",
    value: "north-macedon",
    optionType: "primary",
    capital: "Skopje",
    capitalCoords: {
      lat: 41.9961,
      long: 21.4317,
    },
  },
  {
    id: 130,
    label: "Norway",
    value: "norway",
    optionType: "primary",
    capital: "Oslo",
    capitalCoords: {
      lat: 59.9133,
      long: 10.7389,
    },
  },
  {
    id: 131,
    label: "Oman",
    value: "oman",
    optionType: "primary",
    capital: "Muscat",
    capitalCoords: {
      lat: 23.6139,
      long: 58.5922,
    },
  },
  {
    id: 132,
    label: "Pakistan",
    value: "pakistan",
    optionType: "primary",
    capital: "Islamabad",
    capitalCoords: {
      lat: 33.6931,
      long: 73.0639,
    },
  },
  {
    id: 133,
    label: "Palau",
    value: "palau",
    optionType: "primary",
    capital: "Ngerulmud",
    capitalCoords: {
      lat: 7.5006,
      long: 134.6242,
    },
  },
  {
    id: 134,
    label: "Panama",
    value: "panama",
    optionType: "primary",
    capital: "Panama City",
    capitalCoords: {
      lat: 8.9833,
      long: -79.5167,
    },
  },
  {
    id: 135,
    label: "Papua New Guinea",
    value: "papua-n-g",
    optionType: "primary",
    capital: "Port Moresby",
    capitalCoords: {
      lat: -9.4789,
      long: 147.1494,
    },
  },
  {
    id: 136,
    label: "Paraguay",
    value: "paraguay",
    optionType: "primary",
    capital: "Asunción",
    capitalCoords: {
      lat: -25.3,
      long: -57.6333,
    },
  },
  {
    id: 137,
    label: "Peru",
    value: "peru",
    optionType: "primary",
    capital: "Lima",
    capitalCoords: {
      lat: -12.06,
      long: -77.0375,
    },
  },
  {
    id: 138,
    label: "Philippines",
    value: "philippines",
    optionType: "primary",
    capital: "Manila",
    capitalCoords: {
      lat: 14.5958,
      long: 120.9772,
    },
  },
  {
    id: 139,
    label: "Poland",
    value: "poland",
    optionType: "primary",
    capital: "Warsaw",
    capitalCoords: {
      lat: 52.23,
      long: 21.0111,
    },
  },
  {
    id: 140,
    label: "Portugal",
    value: "portugal",
    optionType: "primary",
    capital: "Lisbon",
    capitalCoords: {
      lat: 38.7253,
      long: -9.15,
    },
  },
  {
    id: 141,
    label: "Qatar",
    value: "qatar",
    optionType: "primary",
    capital: "Doha",
    capitalCoords: {
      lat: 25.2867,
      long: 51.5333,
    },
  },
  {
    id: 142,
    label: "Romania",
    value: "romania",
    optionType: "primary",
    capital: "Bucharest",
    capitalCoords: {
      lat: 44.4325,
      long: 26.1039,
    },
  },
  {
    id: 143,
    label: "Russia",
    value: "russia",
    optionType: "primary",
    capital: "Moscow",
    capitalCoords: {
      lat: 55.7558,
      long: 37.6172,
    },
  },
  {
    id: 144,
    label: "Rwanda",
    value: "rwanda",
    optionType: "primary",
    capital: "Kigali",
    capitalCoords: {
      lat: -1.9439,
      long: 30.0594,
    },
  },
  {
    id: 145,
    label: "Saint Kitts and Nevis",
    value: "saint-k-n",
    optionType: "primary",
    capital: "Basseterre",
    capitalCoords: {
      lat: 17.3,
      long: -62.7333,
    },
  },
  {
    id: 146,
    label: "Saint Lucia",
    value: "saint-lucia",
    optionType: "primary",
    capital: "Castries",
    capitalCoords: {
      lat: 14.0167,
      long: -60.9833,
    },
  },
  {
    id: 147,
    label: "Saint Vincent and the Grenadines",
    value: "saint-v-g",
    optionType: "primary",
    capital: "Kingstown",
    capitalCoords: {
      lat: 13.1578,
      long: -61.225,
    },
  },
  {
    id: 148,
    label: "Samoa",
    value: "samoa",
    optionType: "primary",
    capital: "Apia",
    capitalCoords: {
      lat: -13.8333,
      long: -171.75,
    },
  },
  {
    id: 149,
    label: "San Marino",
    value: "san-marino",
    optionType: "primary",
    capital: "City Of San Marino",
    capitalCoords: { lat: 34.1213, long: -118.132607 },
  },
  {
    id: 150,
    label: "Sao Tome and Principe",
    value: "sao-tome-p",
    optionType: "primary",
    capital: "São Tomé",
    capitalCoords: {
      lat: 0.3361,
      long: 6.7306,
    },
  },
  {
    id: 151,
    label: "Saudi Arabia",
    value: "saudi-arabia",
    optionType: "primary",
    capital: "Riyadh",
    capitalCoords: {
      lat: 24.6333,
      long: 46.7167,
    },
  },
  {
    id: 152,
    label: "Senegal",
    value: "senegal",
    optionType: "primary",
    capital: "Dakar",
    capitalCoords: {
      lat: 14.6928,
      long: -17.4467,
    },
  },
  {
    id: 153,
    label: "Serbia",
    value: "serbia",
    optionType: "primary",
    capital: "Belgrade",
    capitalCoords: {
      lat: 44.82,
      long: 20.46,
    },
  },
  {
    id: 154,
    label: "Seychelles",
    value: "seychelles",
    optionType: "primary",
    capital: "Victoria",
    capitalCoords: {
      lat: 48.4283,
      long: -123.3647,
    },
  },
  {
    id: 155,
    label: "Sierra Leone",
    value: "sierra-leone",
    optionType: "primary",
    capital: "Freetown",
    capitalCoords: {
      lat: 8.4844,
      long: -13.2344,
    },
  },
  {
    id: 156,
    label: "Singapore",
    value: "singapore",
    optionType: "primary",
    capital: "Singapore",
    capitalCoords: {
      lat: 1.3,
      long: 103.8,
    },
  },
  {
    id: 157,
    label: "Slovakia",
    value: "slovakia",
    optionType: "primary",
    capital: "Bratislava",
    capitalCoords: {
      lat: 48.1439,
      long: 17.1097,
    },
  },
  {
    id: 158,
    label: "Slovenia",
    value: "slovenia",
    optionType: "primary",
    capital: "Ljubljana",
    capitalCoords: {
      lat: 46.0514,
      long: 14.5061,
    },
  },
  {
    id: 159,
    label: "Solomon Islands",
    value: "solomon-i",
    optionType: "primary",
    capital: "Honiara",
    capitalCoords: {
      lat: -9.4319,
      long: 159.9556,
    },
  },
  {
    id: 160,
    label: "Somalia",
    value: "somalia",
    optionType: "primary",
    capital: "Mogadishu",
    capitalCoords: {
      lat: 2.0392,
      long: 45.3419,
    },
  },
  {
    id: 161,
    label: "South Africa",
    value: "south-africa",
    optionType: "primary",
    capital: "Pretoria",
    capitalCoords: {
      lat: -25.7461,
      long: 28.1881,
    },
  },
  {
    id: 162,
    label: "South Sudan",
    value: "south-sudan",
    optionType: "primary",
    capital: "Juba",
    capitalCoords: {
      lat: 4.85,
      long: 31.6,
    },
  },
  {
    id: 163,
    label: "Spain",
    value: "spain",
    optionType: "primary",
    capital: "Madrid",
    capitalCoords: {
      lat: 40.4169,
      long: -3.7033,
    },
  },
  {
    id: 164,
    label: "Sri Lanka",
    value: "sri-lanka",
    optionType: "primary",
    capital: "Sri Jayawardenepura Kotte",
    capitalCoords: { lat: 6.883201, long: 79.906982 },
  },
  {
    id: 165,
    label: "Sudan",
    value: "sudan",
    optionType: "primary",
    capital: "Khartoum",
    capitalCoords: {
      lat: 15.6,
      long: 32.5,
    },
  },
  {
    id: 166,
    label: "Suriname",
    value: "suriname",
    optionType: "primary",
    capital: "Paramaribo",
    capitalCoords: {
      lat: 5.8522,
      long: -55.2039,
    },
  },
  {
    id: 167,
    label: "Sweden",
    value: "sweden",
    optionType: "primary",
    capital: "Stockholm",
    capitalCoords: {
      lat: 59.3294,
      long: 18.0686,
    },
  },
  {
    id: 168,
    label: "Switzerland",
    value: "switzerland",
    optionType: "primary",
    capital: "Bern",
    capitalCoords: {
      lat: 46.9481,
      long: 7.4475,
    },
  },
  {
    id: 169,
    label: "Syria",
    value: "syria",
    optionType: "primary",
    capital: "Damascus",
    capitalCoords: {
      lat: 33.5131,
      long: 36.2919,
    },
  },
  {
    id: 170,
    label: "Taiwan",
    value: "taiwan",
    optionType: "primary",
    capital: "Taipei",
    capitalCoords: {
      lat: 25.0375,
      long: 121.5625,
    },
  },
  {
    id: 171,
    label: "Tajikistan",
    value: "tajikistan",
    optionType: "primary",
    capital: "Dushanbe",
    capitalCoords: {
      lat: 38.5367,
      long: 68.78,
    },
  },
  {
    id: 172,
    label: "Tanzania",
    value: "tanzania",
    optionType: "primary",
    capital: "Dodoma",
    capitalCoords: {
      lat: -6.1731,
      long: 35.7419,
    },
  },
  {
    id: 173,
    label: "Thailand",
    value: "thailand",
    optionType: "primary",
    capital: "Bangkok",
    capitalCoords: {
      lat: 13.7525,
      long: 100.4942,
    },
  },
  {
    id: 174,
    label: "Timor-Leste",
    value: "timor-leste",
    optionType: "primary",
    capital: "Dili",
    capitalCoords: {
      lat: -8.5536,
      long: 125.5783,
    },
  },
  {
    id: 175,
    label: "Togo",
    value: "togo",
    optionType: "primary",
    capital: "Lomé",
    capitalCoords: {
      lat: 6.1319,
      long: 1.2228,
    },
  },
  {
    id: 176,
    label: "Tonga",
    value: "tonga",
    optionType: "primary",
    capital: "Nuku'alofa",
    capitalCoords: { lat: -21.136065, long: -175.208939 },
  },
  {
    id: 177,
    label: "Trinidad and Tobago",
    value: "trinidad-t",
    optionType: "primary",
    capital: "Port Of Spain",
    capitalCoords: {
      lat: 10.6667,
      long: -61.5167,
    },
  },
  {
    id: 178,
    label: "Tunisia",
    value: "tunisia",
    optionType: "primary",
    capital: "Tunis",
    capitalCoords: {
      lat: 36.8064,
      long: 10.1817,
    },
  },
  {
    id: 179,
    label: "Turkey",
    value: "turkey",
    optionType: "primary",
    capital: "Ankara",
    capitalCoords: {
      lat: 39.93,
      long: 32.85,
    },
  },
  {
    id: 180,
    label: "Turkmenistan",
    value: "turkmenistan",
    optionType: "primary",
    capital: "Ashgabat",
    capitalCoords: {
      lat: 37.9375,
      long: 58.38,
    },
  },
  {
    id: 181,
    label: "Tuvalu",
    value: "tuvalu",
    optionType: "primary",
    capital: "Funafuti",
    capitalCoords: {
      lat: -8.5167,
      long: 179.2,
    },
  },
  {
    id: 182,
    label: "Uganda",
    value: "uganda",
    optionType: "primary",
    capital: "Kampala",
    capitalCoords: {
      lat: 0.3136,
      long: 32.5811,
    },
  },
  {
    id: 183,
    label: "Ukraine",
    value: "ukraine",
    optionType: "primary",
    capital: "Kyiv",
    capitalCoords: {
      lat: 50.45,
      long: 30.5233,
    },
  },
  {
    id: 184,
    label: "United Arab Emirates",
    value: "uae",
    optionType: "primary",
    capital: "Abu Dhabi",
    capitalCoords: {
      lat: 24.4667,
      long: 54.3667,
    },
  },
  {
    id: 185,
    label: "United Kingdom",
    value: "uk",
    optionType: "primary",
    capital: "London",
    capitalCoords: {
      lat: 51.5072,
      long: -0.1275,
    },
  },
  {
    id: 186,
    label: "United States, East",
    value: "us-east",
    optionType: "primary",
    capital: "Ohio",
    capitalCoords: { lat: 40.367474, long: -82.996216 },
  },
  {
    id: 187,
    label: "United States, West",
    value: "us-west",
    optionType: "primary",
    capital: "Oregon",
    capitalCoords: { lat: 44.0, long: -120.5 },
  },
  {
    id: 188,
    label: "United States, Central",
    value: "us-central",
    optionType: "primary",
    capital: "Texas",
    capitalCoords: { lat: 31.0, long: -100.0 },
  },
  {
    id: 189,
    label: "Uruguay",
    value: "uruguay",
    optionType: "primary",
    capital: "Montevideo",
    capitalCoords: {
      lat: -34.8836,
      long: -56.1819,
    },
  },
  {
    id: 190,
    label: "Uzbekistan",
    value: "uzbekistan",
    optionType: "primary",
    capital: "Tashkent",
    capitalCoords: {
      lat: 41.3111,
      long: 69.2797,
    },
  },
  {
    id: 191,
    label: "Vanuatu",
    value: "vanuatu",
    optionType: "primary",
    capital: "Port Vila",
    capitalCoords: { lat: -17.7333, long: 168.3167 },
  },
  {
    id: 192,
    label: "Vatican City",
    value: "vatican-c",
    optionType: "primary",
    capital: "Vatican City",
    capitalCoords: {
      lat: 41.904,
      long: 12.453,
    },
  },
  {
    id: 193,
    label: "Venezuela",
    value: "venezuela",
    optionType: "primary",
    capital: "Caracas",
    capitalCoords: {
      lat: 10.4806,
      long: -66.9036,
    },
  },
  {
    id: 194,
    label: "Vietnam",
    value: "vietnam",
    optionType: "primary",
    capital: "Hanoi",
    capitalCoords: {
      lat: 21,
      long: 105.85,
    },
  },
  {
    id: 195,
    label: "Yemen",
    value: "yemen",
    optionType: "primary",
    capital: "Sana'a",
    capitalCoords: { lat: 15.369445, long: 44.191006 },
  },
  {
    id: 196,
    label: "Zambia",
    value: "zambia",
    optionType: "primary",
    capital: "Lusaka",
    capitalCoords: {
      lat: -15.4167,
      long: 28.2833,
    },
  },
  {
    id: 197,
    label: "Zimbabwe",
    value: "zimbabwe",
    optionType: "primary",
    capital: "Harare",
    capitalCoords: {
      lat: -17.8292,
      long: 31.0522,
    },
  },
];

export default Regions;
